var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPolicy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.2998 4.5L8.49981 4.5M0.799805 13.6L0.799804 2.4C0.799804 2.02869 0.947303 1.6726 1.20985 1.41005C1.4724 1.1475 1.8285 0.999998 2.1998 0.999998L10.5998 0.999997C10.9711 0.999997 11.3272 1.1475 11.5898 1.41005C11.8523 1.6726 11.9998 2.02869 11.9998 2.4L11.9998 10.5606C11.9998 10.7471 11.9625 10.9317 11.8901 11.1036C11.8178 11.2755 11.7118 11.4312 11.5784 11.5616L8.47041 14.601C8.20886 14.8567 7.85761 15 7.49181 15L2.1998 15C1.8285 15 1.47241 14.8525 1.20986 14.5899C0.947304 14.3274 0.799805 13.9713 0.799805 13.6Z",
    stroke: "#FA9418",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.7998 15L7.7998 12.2C7.7998 11.8287 7.9473 11.4726 8.20986 11.21C8.47241 10.9475 8.8285 10.8 9.1998 10.8L11.9998 10.8",
    stroke: "#FA9418",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.2998 7.30005L7 7.30005",
    stroke: "#D61D4F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolicy);
export default __webpack_public_path__ + "static/media/policy.659885817756f686ae4949e16d5b3b6c.svg";
export { ForwardRef as ReactComponent };